import React from "react";
import { Stack } from "@mui/material";

import { HubHookCustomersSelect, HubHookFormSwitch } from "../../components";

const MergeCustomerForm = ({ disabled = false }) => {
  return (
    <Stack width="100%" gap="15px">
      <HubHookCustomersSelect
        name="mainCustomerId"
        label="Main Customer"
        disabled={disabled}
      />
      <HubHookCustomersSelect
        name="oldCustomerId"
        label="Customer to Merge"
        disabled={disabled}
      />
      <HubHookFormSwitch
        name="confirm"
        label="I confirm these changes cannot be undone"
        labelPlacement="end"
        disabled={disabled}
        isCheckbox
        required
      />
    </Stack>
  );
};

export default MergeCustomerForm;
